import * as React from 'react'

import { trackEvent } from '../../../../../../../lib/analytics'
import { ErrorMessage } from '../shared-form-styles'

import { Body, CharacterCount, Input, Wrapper } from './styles'

interface Props {
  ariaLabelledby?: string
  disabled?: boolean
  errorMessage?: string
  maxCharacterCount: number
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onInput?: (event: React.FormEvent<HTMLInputElement>) => void
  placeholder: string
  value: string | undefined
}

export const EmbroideryTextInput: React.FC<Props> = ({
  ariaLabelledby,
  disabled,
  errorMessage,
  maxCharacterCount,
  name,
  onChange,
  onInput,
  placeholder,
  value,
}) => {
  return (
    <Wrapper disabled={disabled ?? false}>
      <Body hasValue={!!value} isInvalid={!!errorMessage}>
        <Input
          disabled={disabled ?? false}
          maxLength={maxCharacterCount}
          name={name}
          onChange={onChange}
          onInput={onInput}
          placeholder={placeholder}
          type='text'
          value={value}
          {...trackEvent({
            category: 'embroidery',
            action: 'click',
            label: name,
            value: value,
          })}
          aria-labelledby={ariaLabelledby}
        />

        <CharacterCount disabled={disabled ?? false}>
          {value?.length ?? 0}/{maxCharacterCount}
        </CharacterCount>
      </Body>

      {errorMessage && <ErrorMessage role='alert'>{errorMessage}</ErrorMessage>}
    </Wrapper>
  )
}
